import { Link, createFileRoute, notFound } from '@tanstack/react-router'
import { SiteFooter } from '../../components/SiteFooter'
import { SiteHeader } from '../../components/SiteHeader'
import { useLocale } from '../../components/use-locale'
import { pomodoroDoc } from '../../content/pomodoro'
import { getDict, parseLocale } from '../../i18n'
import { seoHead } from '../../lib/seo'
import { SITE_ORIGIN } from '../../lib/site'

export const Route = createFileRoute('/{-$locale}/pomodoro')({
  beforeLoad: ({ params }) => {
    if (!parseLocale(params.locale)) throw notFound()
  },
  head: ({ params }) => {
    const locale = parseLocale(params.locale) ?? 'ja'
    const { doc } = pomodoroDoc(locale)
    return seoHead({
      origin: SITE_ORIGIN,
      locale,
      path: '/pomodoro',
      title: getDict(locale).meta.pomodoroTitle,
      description: doc.description,
    })
  },
  component: PomodoroPage,
})

function PomodoroPage() {
  const { locale, t, path } = useLocale()
  const { doc, lang } = pomodoroDoc(locale)
  return (
    <>
      <SiteHeader variant="solid" />
      <main id="main" className="legal">
        {lang !== locale && <p className="legal__notice">{t.legal.englishOnly}</p>}
        <article className="legal__doc" lang={lang === locale ? undefined : lang}>
          <h1 className="legal__title">{doc.title}</h1>
          <p className="legal__lead">{doc.intro}</p>
          {doc.sections.map((s) => (
            <section key={s.heading} className="legal__section">
              <h2>{s.heading}</h2>
              {s.body.map((p) => (
                <p key={p}>{p}</p>
              ))}
            </section>
          ))}
        </article>
        <Link to={path('/cafe')} className="btn btn--lamp">
          {t.log.cta}
        </Link>
      </main>
      <SiteFooter />
    </>
  )
}
